import React from 'react';
import { connect } from 'react-redux';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import Lightbox from 'react-images';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { withStyles, WithStyles, Theme, createStyles } from '@material-ui/core/styles';
import CardGiftcard from '@material-ui/icons/CardGiftcard';
import { AppBar, Grid, Hidden, Icon, Toolbar, Tooltip, Typography, Paper, Link } from '@material-ui/core';
import ContactSupport from '@material-ui/icons/ContactSupport';
import Star from '@material-ui/icons/Star';
import CalendarToday from '@material-ui/icons/CalendarToday';
import AttachMoney from '@material-ui/icons/AttachMoney';
import Info from '@material-ui/icons/Info';
import ListIcon from '@material-ui/icons/List';
import PhoneIcon from '@material-ui/icons/Phone';
import MailIcon from '@material-ui/icons/Mail';
import People from '@material-ui/icons/People';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import classnames from 'classnames';

const styles = (theme: Theme) => createStyles({});

interface Studio {
  email?: string;
  phone?: string;
  telegram?: string;
  viber?: string;
  [key: string]: any;
}

interface StudioContactWidgetProps extends WithStyles<typeof styles> {
  studio: Studio;
  translate: (key: string, data?: any) => string;
  currentLanguage: string;
  user: any;
  domain: {
    staticUrl: string;
    [key: string]: any;
  };
}

class StudioContactWidget extends React.Component<StudioContactWidgetProps> {
  componentDidMount() {}

  render = () => {
    return (
      <Grid container spacing={1} alignItems="center">
        {this.renderPhone()}
        {this.renderEmail()}
        {this.renderTelegram()}
        {this.renderViber()}
      </Grid>
    );
  };

  renderEmail = () => {
    if (this.props.studio.email) {
      const email = this.props.studio.email;
      return (
        <Grid item>
          <Link href={`mailto:${email}`}>
            <MailIcon />
          </Link>
        </Grid>
      );
    }
    return null;
  };

  renderPhone = () => {
    if (this.props.studio.phone) {
      const phone = this.props.studio.phone;
      return (
        <Grid item>
          <Link href={`tel:${phone}`}>
            <PhoneIcon />
          </Link>
        </Grid>
      );
    }
    return null;
  };

  renderTelegram = () => {
    if (this.props.studio.telegram) {
      const telegram = this.props.studio.telegram;
      return (
        <Grid item>
          <Link href={telegram}>
            <Icon>
              <img src={`${this.props.domain.staticUrl}/telegram.svg`} height={24} width={24} alt="Telegram" />
            </Icon>
          </Link>
        </Grid>
      );
    }
    return null;
  };

  renderViber = () => {
    if (this.props.studio.viber) {
      const viber = this.props.studio.viber;
      return (
        <Grid item>
          <Link href={viber}>
            <Icon>
              <img src={`${this.props.domain.staticUrl}/viber.svg`} height={24} width={24} alt="Viber" />
            </Icon>
          </Link>
        </Grid>
      );
    }
    return null;
  };
}

const mapStateToProps = (state: any) => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
  user: state.user,
  domain: state.domain,
});

const mapDispatchToProps = () => {
  return {};
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(StudioContactWidget));
